<form class="form-horizontal" [formGroup]="pageForm">
  <div class="card-body mb-5">
    <div
      *ngFor="let error of errorsList"
      class="alert alert-danger text-center"
      role="alert"
    >
      {{ error }}
    </div>
    <div class="row ps-2 mt-3">
      <div class="col-md-6 col-6 border-end">
        <h3>{{ pageText?.left_header }}</h3>
        <h6 class="ps-2 mt-4">{{ pageText?.left_subtext }}</h6>

        <div class="row ps-2 mt-4">
          <div class="col-md-4">
            <label class="h5 pt-2" for="ltf">{{ pageText?.lbl_ltf }}</label>
          </div>
          <div class="col-md-5 ps-0">
            <input
              type="text"
              class="form-control"
              id="ltf"
              formControlName="ltf"
            />
          </div>
        </div>

        <div class="row ps-2 mt-4">
          <div class="col-md-4">
            <label class="h5 pt-2" for="company">{{
              pageText?.lbl_companyName
            }}</label>
          </div>
          <div class="col-md-5 ps-0">
            <input
              type="text"
              class="form-control"
              id="company"
              formControlName="company"
            />
          </div>
        </div>

        <div class="row ps-2 mt-4">
          <div class="col-md-4">
            <label class="h5 pt-2" for="facility">{{
              pageText?.lbl_facilityName
            }}</label>
          </div>
          <div class="col-md-5 ps-0">
            <input
              type="text"
              class="form-control"
              id="facility"
              formControlName="facility"
            />
          </div>
        </div>

        <div class="row ps-2 mt-4">
          <div class="col-md-4">
            <label class="h5 pt-2" for="county">{{
              pageText?.lbl_county
            }}</label>
          </div>
          <div class="col-md-5 ps-0">
            <custom-dropdown
              [itemList]="utils.countyList"
              id="county"
              formControlName="county"
              [code]="'code'"
              [description]="'desc'"
              [isSearchable]="false"
            >
            </custom-dropdown>
          </div>
        </div>

        <div class="row ps-2 mt-4">
          <div class="offset-md-4 col-md-5 ps-0">
            <button
              type="button"
              class="btn bottom-btn btn-primary float-end"
              (click)="searchData(pageForm.value)"
              [disabled]="!pageForm.value.ltf && !pageForm.value.company && !pageForm.value.facility && (!pageForm.value.county || pageForm.value.county === '-1')"
            >
              <span class="float-start">{{ pageText?.lbl_search }}</span>
              <span class="arrow right float-end">
                <i class="fa fa-chevron-right"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-6">
        <h3>{{ pageText?.right_header }}</h3>

        <div class="row ps-2 mt-4">
          <div class="offset-md-6 col-md-5 ps-0">
            <button
              type="button"
              class="btn bottom-btn btn-primary float-end"
              (click)="viewAll()"
            >
              <span class="float-start">{{ pageText?.lbl_search_all }}</span>
              <span class="arrow right float-end">
                <i class="fa fa-chevron-right"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
</form>
